export const parseTabTags = (tabTag) => {
  if (!tabTag) return [];

  return String(tabTag)
    .split(/[,;]/)
    .map((tag) => tag.trim())
    .filter(Boolean);
};

export const tabHasTag = (tabTag, targetTag) => parseTabTags(tabTag).includes(targetTag);
